export default function(fatArr) {
  return {
    type: "SET_FAT_ARRAY",
    fatArr
  }
}



// WEBPACK FOOTER //
// ./src/actions/setMacrosMealArray/setFatArr.js